import { DrawerTheme, SternumTheme } from '@sternum/ui';

export function SBOMLightDrawerTheme(theme: SternumTheme): Partial<DrawerTheme.DrawerTheme> {
  return {
    textColor: theme.textColor,
  };
}
